import React from "react";
import { MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceAreas() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const locations = [{
    name: "Newcastle",
    delay: "delay-100"
  }, {
    name: "Central Coast",
    delay: "delay-300"
  }, {
    name: "Sydney",
    delay: "delay-500"
  }];
  return <section id="serviceareas" ref={ref} className="relative w-full bg-[#0A0A0A] py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-20">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-neutral-800/20 via-transparent to-transparent" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {}
        <div className={`text-center mb-20 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4 tracking-tight">
            Our Service Areas
          </h2>
          <p className="text-neutral-400 max-w-2xl mx-auto text-lg">
            Providing the gold standard in commercial cleaning from Newcastle to Sydney.
          </p>
        </div>

        {}
        <div className="relative max-w-3xl mx-auto min-h-[500px] flex flex-col justify-center items-center">
          
          {}
          <div className="absolute inset-y-0 left-1/2 -translate-x-1/2 w-24 h-full pointer-events-none">
            <svg className="w-full h-full" viewBox="0 0 100 600" preserveAspectRatio="none" fill="none" xmlns="http://www.w3.org/2000/svg">
              {}
              <path d="M50,0 C55,50 45,100 50,150 C55,200 48,250 50,300 C52,350 45,400 50,450 C55,500 48,550 50,600" stroke="#333333" strokeWidth="2" strokeLinecap="round" className={`transition-all duration-[2000ms] ease-out ${isVisible ? "path-draw" : "opacity-0"}`} style={{
              strokeDasharray: isVisible ? "1000" : "0",
              strokeDashoffset: isVisible ? "0" : "1000"
            }} />
            </svg>
          </div>

          {}
          <div className="w-full flex flex-col gap-24 md:gap-32 py-10">
            {locations.map((loc, i) => <div key={loc.name} data-index={i} className={`relative flex items-center justify-center w-full transition-all duration-700 ${loc.delay} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                {}
                <div className="flex-1 text-right pr-6 md:pr-12">
                  <span className="text-white font-sans uppercase tracking-[0.15em] text-sm md:text-base font-medium">
                    {loc.name}
                  </span>
                </div>

                {}
                <div className="relative flex-none w-4 h-4 flex items-center justify-center z-20">
                  {}
                  <div className="absolute inset-0 rounded-full bg-[#FFC107] animate-ping opacity-75" />
                  {}
                  <div className="w-3 h-3 md:w-4 md:h-4 bg-[#FFC107] rounded-full relative z-10" style={{
                boxShadow: "0 0 15px 5px rgba(255, 193, 7, 0.6)"
              }} />
                </div>

                {}
                <div className="flex-1 pl-0 flex items-center">
                  <div className="h-[1px] w-16 md:w-32 border-t border-dashed border-[#FFC107]/60 origin-left transition-all duration-1000 delay-500" style={{
                transform: isVisible ? "scaleX(1)" : "scaleX(0)"
              }} />
                </div>
              </div>)}
          </div>
        </div>

        {}
        <div className={`mt-20 text-center transition-all duration-700 delay-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <p className="text-neutral-400 mb-6">
            Not sure if we cover your area? Contact us to find out.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button asChild size="lg" className="bg-[#FFC107] text-black hover:bg-[#FFC107]/90 font-semibold rounded-full px-8">
                <Link to="/ContactUsPage">
                    Check Availability
                </Link>
            </Button>
            <Button asChild variant="outline" size="lg" className="border-neutral-700 text-white hover:bg-neutral-800 hover:text-white rounded-full px-8">
                <Link to="/ServicesPage" className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-all [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive border bg-background shadow-xs h-10 has-[>svg]:px-4 border-neutral-700 rounded-full px-8 !text-[hsl(0,0%,0%)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 dark:bg-input/30 dark:border-input dark:hover:bg-input/50 hover:bg-neutral-800 hover:text-white">
                    View Services
                </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}